var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modatta-achievements"},[_c('div',{staticClass:"modatta-container"},[_c('h4',[_vm._v("What we achieved")])])])
}]

export { render, staticRenderFns }